import { render, staticRenderFns } from "./StudentInvitationDialog.vue?vue&type=template&id=f42ca03e&scoped=true&"
import script from "./StudentInvitationDialog.vue?vue&type=script&lang=js&"
export * from "./StudentInvitationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f42ca03e",
  null
  
)

export default component.exports